<div
    class="mp-welcome-card trezo-card mb-25 border-radius d-block border-0 shadow-none"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="trezo-card-content">
        <div class="content">
            <h5 class="fw-semibold text-white">
                Welcome Back, <span>Olivia!</span>
            </h5>
            <p class="text-white">
                Your progress this week is Awesome.
            </p>
            <div class="extra-space"></div>
            <div class="d-md-flex align-items-center">
                <div class="item d-flex align-items-center">
                    <div class="icon text-danger bg-danger-200 border-radius d-flex align-items-center justify-content-center">
                        <i class="material-symbols-outlined">
                            airplay
                        </i>
                    </div>
                    <div>
                        <span class="title d-block fw-semibold text-white">
                            75h
                        </span>
                        <span class="d-block">
                            Hours Spent
                        </span>
                    </div>
                </div>
                <div class="item d-flex align-items-center">
                    <div class="icon text-success bg-success-100 border-radius d-flex align-items-center justify-content-center">
                        <i class="material-symbols-outlined">
                            local_library
                        </i>
                    </div>
                    <div>
                        <span class="title d-block fw-semibold text-white">
                            15
                        </span>
                        <span class="d-block">
                            Projects Completed
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="image">
            <img src="images/online-learning.gif" alt="online-learning-image">
        </div>
    </div>
</div>